export const visit = (vm, at) => {
at({ "vi": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "R\u1EA5t ti\u1EBFc, ch\xFAng t\xF4i kh\xF4ng th\u1EC3 x\xE1c minh \u0111\u1ECBa ch\u1EC9 email c\u1EE7a b\u1EA1n." } } } });
};